import React from "react";
import { ExpandedTable } from "../../ui-kit";

import styles from "./SkeletonTable.module.scss";

export interface ISkeletonProps {
  className?: string;
  rowsLength?: number;
  columns?: Array<unknown>;
  isExpanded?: boolean
}

export const SkeletonTable: React.FC<ISkeletonProps> = ({
  className = "",
  rowsLength = 0,
  columns = [],
  isExpanded = false,
}) => {
  const data = Array(rowsLength)
    .fill("")
    .map((item, key) => {
      return { id: key };
    });

  const skeletonColumns = columns.map((column, key) => {
    return key
      ? {
          ...column,
          render: (text, record, index) => (
            <div className={styles.skeleton}></div>
          ),
        }
      : column;
  });

  return (
    <ExpandedTable
      columns={skeletonColumns}
      data={data}
      className={className}
      rowKey={(record) => record.id}
    >
      {isExpanded ? <div></div> : null}
    </ExpandedTable>
  );
};
